import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import MethodologySection from './components/MethodologySection';
import PrinciplesSection from './components/PrinciplesSection';
import AboutSection from './components/AboutSection';
import PartnersSection from './components/PartnersSection';
import CTASection from './components/CTASection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#011820]">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <MethodologySection />
        <PrinciplesSection />
        <AboutSection />
        <PartnersSection />
        <CTASection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
